export const extraData: any = {
  'G-232': {
    position: [0, 0, 0],
    rotation: [0, 90, 0],
    scale: 0.65,
  },
  'G-091': {
    position: [-2.5, 0, 1],
    rotation: [0, -90, 0],
    scale: 1.2,
  },
  'G-234': {
    position: [-1, 0, -2.5],
    rotation: [0, 180, 0],
    scale: 1,
  },
  'G-414': {
    position: [1.5, 0, -2.5],
    rotation: [0, 0, 0],
    scale: 1,
  },
  'G-140': {
    scale: 0.1,
  },
};
